<template>
  <div class="cruise">
    <a class="cruise__image" title="" @click="zoomEvent">
      <img
        :src="require(`@/assets/img/privateCruising/${this.image}`)"
        alt="RIVA68"
      />
      <div class="cruise__image__icon">
        <img :src="require(`@/assets/img/common/icon_expan.png`)" />
      </div>
    </a>
    <ul class="spec">
      <li>
        <span class="name">
          {{ culusingName }}
          <span class="marina">
            {{ marina }}
          </span>
        </span>
      </li>
      <li>{{ hull }}</li>
      <li>{{ fullLength }}</li>
      <li>{{ capacity }}</li>
      <li>{{ equipment }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    culusingName: String,
    marina: String,
    hull: String,
    fullLength: String,
    capacity: String,
    equipment: String,
  },
  methods: {
    zoomEvent() {
      let image = this.image.replace("s", "");
      this.$store.dispatch("zoom/show", ["privateCruising", image]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/privateCruising/cruiser.scss";
</style>
